module.exports = __webpack_public_path__ + "img/5.5dc99bbb.png";